import { render, staticRenderFns } from "./FaultDataList.vue?vue&type=template&id=50678a8d&scoped=true"
import script from "./FaultDataList.vue?vue&type=script&lang=js"
export * from "./FaultDataList.vue?vue&type=script&lang=js"
import style0 from "./FaultDataList.vue?vue&type=style&index=0&id=50678a8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50678a8d",
  null
  
)

export default component.exports